import {forwardRef} from "react";
import {InputProps, TextInput} from "./text-input";
import * as React from "react";
import * as _ from "lodash";

interface FormikTextInputProps extends InputProps {
  formik: any,
  required?: boolean,
  name: string,
  'data-test'?: string,
}

export const FormikTextInput = forwardRef((props: FormikTextInputProps, ref: any) => {
  const {formik, required, name, ...rest} = props;

  return <TextInput
    ref={ref}
    value={formik.values[name]}
    onChange={formik.handleChange}
    error={formik.touched[name] && Boolean(formik.errors[name])}
    helperText={formik.touched[name] && formik.errors[name]}
    name={name}
    label={typeof rest.label === 'undefined' ? `${_.startCase(name)}${required ? ' *' : ''}` : rest.label}
    data-test={props['data-test'] || _.snakeCase(name)}
    placeholder={rest.placeholder || _.startCase(name)}
    {...rest}
  />
})
